import React from "react";
import { Modal, Divider, Flex, Button, Form, Input, message, Radio, InputNumber } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";




const Regist = () => {
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [actionUrl, setActionUrl] = React.useState();
    const [isOpen, setIsOpen] = React.useState(false);
    const [svgData, setSvgData] = React.useState();

    const onRegist = async () => {
        try {
            const url = new URL(window.location.href);
            const values = await form.validateFields();
            console.log("Success:", values);

            let response = await fetch(`/api/login/regist${url.search}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            let result = await response.json();

            if (result && result.success) {
                // message.success("注册成功！");
                setTimeout(() => {
                    window.location.href = `/regist2?accId=${result.data.accId}`;
                }, 500);
            } else {
                message.error(result.data);
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo);
        }
    };

    const getSvgData = async (phoneNo) => {
        const res = await fetch(`/api/sms/svg?phoneNo=${phoneNo}`);
        const result = await res.json();
        
        if(result && result.success) {
            console.log(result.data.svg);
            setSvgData(result.data.svg);
            setIsOpen(true);
        } else {
            message.error(result.data);
        }
    };

    const onGetCodeClick = async () => { 
        await form.validateFields(["phoneNo"]);
        await getSvgData(form.getFieldValue("phoneNo"));

        
    };

    const sendSmsCode = async () => { 
        const phoneNo = form.getFieldValue("phoneNo");
        const code = document.getElementById("codeInput").value;

        if(phoneNo && code) {
            const response = await fetch(`/api/sms/send-code?phoneNo=${phoneNo}&code=${code}`);
            const result = await response.json();

            if(result.success) {
                message.success("验证码发送成功");
                setIsOpen(false);
            } else {
                message.error(result.data);
            }
        } else {
            message.error("请输入手机号和验证码");
        }
    };

    return (
        <div>
            <Modal open={isOpen} destroyOnClose={true} onCancel={() => setIsOpen(false)} onOk={sendSmsCode}>
                <div style={{ width: '100px', height: '50px'}} dangerouslySetInnerHTML={{ __html: svgData }} onClick={() => getSvgData(form.getFieldValue("phoneNo"))} />
                <Input placeholder="请输入上图中的字符" id='codeInput' />
            </Modal>
            <Form form={form} style={{ maxWidth: "600px", margin: "0 auto" }}>
                
                <h2 style={{textAlign: 'center'}}>注册优选到家</h2>

                <Form.Item
                    label="手机号码"
                    name="phoneNo"
                    rules={[{ required: true, message: "请输入手机号码" }, { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" }]}
                >
                    <InputNumber min={1} maxLength={11} style={{ width: "100%" }} placeholder="请输入手机号码" />
                </Form.Item>

                <Flex gap={10}>
                    <Form.Item
                        label="短信验证码"
                        name="code"
                        rules={[{ required: true, message: "请输入验证码" }]}
                    >
                        <InputNumber min={1} maxLength={6} placeholder="输入验证码" />
                    </Form.Item>
                    <Button onClick={onGetCodeClick}>获取验证码</Button>
                </Flex>
                <Divider />
                <Flex gap={20} justify="center">
                    <Button type="default" href="/login">
                        返回登录
                    </Button>
                    <Button type="primary" onClick={onRegist}>
                        下一步
                    </Button>
                </Flex>
            </Form>
        </div>
        
    );    
};

export default Regist;
